/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Initials/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Initials({
  children,
  viewPath = "/DesignSystem/Avatar/Initials",
  size
  
}) {
let avatarInitialsValueData = fromData.useDataValue({ viewPath,
context: 'avatar',
path: 'initials',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 size={size}
 data="avatar.initials"
 text={avatarInitialsValueData}
/>
{children}
</React.Fragment>)
}